import React, { FC } from 'react';
import styled from 'styled-components';
import { T } from 'src/shared/helpers';

// LA VOCE C'È, IL CONTENUTO NO — ed è voluto (utente, 2026-08-12: «trigger aggiungilo nella
// lista ma al momento non ci mostrare nulla»).
//
// Un trigger point nel prototipo è un punto sul modello con un nome, un colore, un glifo e
// ciò che fa quando lo si tocca. Qui non esiste il punto: c'è il flag `Info Points` sulla
// scena, che accende i punti in blocco, e nessuna entità per il singolo punto — né dato, né
// mutation, né metodo sul motore (docs/scene-editor-new-sections.md § 3).
//
// La sezione esiste comunque perché il rail è una mappa: nascondere la voce racconterebbe
// che i trigger point non fanno parte di questo prodotto, e non è vero — non sono ancora
// costruiti. La differenza fra «non c'è» e «non ancora» la deve vedere anche chi apre.

const Placeholder = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 28px 16px;
    color: ${(props) => props.theme.app.primary};
    font-size: 12px;
    text-align: center;
`;

const PlaceholderTitle = styled.strong`
    color: ${(props) => props.theme.app.textColor};
    font-size: 13px;
`;

const TriggerEditor: FC = () => (
    <Placeholder>
        <PlaceholderTitle>{T._('Trigger points', 'Admin')}</PlaceholderTitle>
        <span>{T._('This section is not built yet.', 'Admin')}</span>
    </Placeholder>
);

export default TriggerEditor;
